export function btoa(str) {
  let buffer;

  if (str instanceof Buffer) {
    buffer = str;
  } else {
    buffer = Buffer.from(str.toString(), 'binary');
  }

  return buffer.toString('base64');
}

export function parseURI() {
  let uriResolved = arguments[0];
  for (let i = 1; i < arguments.length; i++) {
    uriResolved = uriResolved.replace('{' + (i - 1) + '}', arguments[i]);
  }
  return uriResolved;
}

export function objectToQueryString(obj) {
  let parts = [];
  for (let key in obj) {
    if (obj.hasOwnProperty(key) && obj[key]) {
      parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
    }
  }
  return '?' + parts.join('&');
}

export function removeAccentMarks(str) {
  let from = 'ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç';
  let to = 'AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc';
  let mapping = {};

  for (let i = 0, j = from.length; i < j; i++) {
    mapping[from.charAt(i)] = to.charAt(i);
  }

  let result = [];
  for (let i = 0, j = str.length; i < j; i++) {
    let c = str.charAt(i);
    if (mapping.hasOwnProperty(str.charAt(i))) {
      result.push(mapping[c]);
    } else {
      result.push(c);
    }
  }
  return result.join('');
}

export function cloneArray(origin) {
  let destiny = [];
  origin.map(item => {
    destiny.push(Object.assign({}, item));
  });
  return destiny;
}
